import JsonLd from "@/components/JsonLd.tsx";
import JsonLdBreadcrumbList from "@/components/JsonLdBreadcrumbList.tsx";
import {faqJsonLd} from "@/landing/sections/faqData.tsx";
import {createFileRoute} from '@tanstack/react-router'
import NewLandingPage from "../landing/NewLandingPage.tsx";

export const Route = createFileRoute('/')({
    component: Index,
})

function Index() {
    return <>
        <JsonLd id={`page${Route.id}/faq-schema`} item={faqJsonLd()} />
        <JsonLd id={`page${Route.id}/app`} item={{
            "@context":            "https://schema.org",
            "@type":               "SoftwareApplication",
            "name":                "ScorePal",
            "applicationCategory": "BusinessApplication",
            "operatingSystem":     ["Web", "iOS", "Android"],
            "url":                 "https://scorepal.co/",
            "description":         "All-in-one sports management software for clubs and organisers to run leagues, tournaments, teams and matches with registration, payments and live scoring.",
            "offers":              {
                "@type":         "Offer",
                "price":         "0",
                "priceCurrency": "USD",
                "description":   "Free to get started"
            }
        }} />
        <JsonLd id={`page${Route.id}/mobile-app`} item={{
            "@context":            "https://schema.org",
            "@type":               "MobileApplication",
            "name":                "ScorePal",
            "operatingSystem":     ["iOS", "Android"],
            "applicationCategory": "SportsApplication",
            "description":         "Score live matches courtside, follow standings and rankings, and get result notifications from your phone.",
            "downloadUrl":         "https://apps.apple.com/us/app/score-pal/id6745509167",
            "offers":              {
                "@type":         "Offer",
                "price":         "0",
                "priceCurrency": "USD"
            }
        }} />
        <JsonLdBreadcrumbList routeId={Route.id} />
        <NewLandingPage />
    </>
}
